// Pure helpers for the retro desktop hit counter. No Svelte, no DOM — kept
// separate so they can be unit tested directly.

// odometerDigits renders a non-negative integer count as a fixed-width array of
// single-character digit strings, zero-padded to at least minDigits (classic
// odometer look). Negative/NaN counts clamp to zero.
export function odometerDigits(count, minDigits = 6) {
  let n = Math.floor(Number(count));
  if (!Number.isFinite(n) || n < 0) n = 0;
  const str = String(n).padStart(minDigits, '0');
  return str.split('');
}

// visitLabel renders the count as a human sentence, pluralised.
export function visitLabel(count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  return `${n.toLocaleString('en-US')} ${n === 1 ? 'visit' : 'visits'}`;
}

// onlineLabel renders the "online now" flip-side label.
export function onlineLabel(count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  return `${n.toLocaleString('en-US')} online now`;
}
